/* eslint-disable prettier/prettier */
import {
  USER_LOADING,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT_SUCCESS,
  USER_LOCATION,
  UPDATE_USER,
} from './authType'

const initialState = {
  isLoading: false,
  accessToken:
    localStorage.getItem('accessToken') !== null &&
    localStorage.getItem('accessToken') !== 'undefined'
      ? localStorage.getItem('accessToken')
      : null,
  refreshToken:
    localStorage.getItem('refreshToken') !== null &&
    localStorage.getItem('refreshToken') !== 'undefined'
      ? localStorage.getItem('refreshToken')
      : null,
  isAuthenticated:
    localStorage.getItem('accessToken') !== null &&
    localStorage.getItem('accessToken') !== 'undefined'
      ? true
      : false,
  data:
    localStorage.getItem('user') !== null && localStorage.getItem('user') !== 'undefined'
      ? JSON.parse(localStorage.getItem('user'))
      : null,
  location: null,
}

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_LOCATION:
      return {
        ...state,
        location: action.payload,
      }
    case USER_LOADING:
      return {
        ...state,
        loading: true,
      }
    case LOGIN_SUCCESS:
      localStorage.setItem('accessToken', action.payload.accessToken)
      localStorage.setItem('refreshToken', action.payload.refreshToken)
      localStorage.setItem('user', JSON.stringify(action.payload))
      localStorage.setItem('username', action.payload.email)
      return {
        ...state,
        data: action.payload,
        isAuthenticated: true,
        isLoading: false,
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
      }
    case UPDATE_USER:
      localStorage.setItem('user', JSON.stringify(action.payload))
      return {
        ...state,
        data: action.payload,
      }
    case LOGIN_FAIL:
    case LOGOUT_SUCCESS:
      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('user')
      return {
        ...state,
        accessToken: null,
        refreshToken: null,
        data: null,
        isAuthenticated: false,
        isLoading: false,
      }
    default:
      return state
  }
}

export default authReducer
